import React from 'react';
import styled from 'styled-components';
import { ProgressBar } from '@superops/ui-design-system';

const StyledStep = styled.div`
  display: flex;
  align-items: center;

  .text {
    padding: 0px 8px;
  }
`;

function StepCell() {
  return (
    <StyledStep>
      <ProgressBar progress={40} size="small" />
      <div className="text">4/4</div>
    </StyledStep>
  );
}

export default StepCell;
